/* @flow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import _ from 'lodash';
import cx from 'classnames';
import { Col, Table } from 'reactstrap';

import classes from './TableSelectionGroup.scss';
import { getFieldValues, getDirtyFields } from '../../selectors/design';
import { HashId } from '../../utils';

type PropsType = {
  changed: boolean,
  changeInput: Function,
  dataTarget: string,
  defaultVal: string,
  dirtyVal: string,
  error: string[],
  id: string,
  inducerPos: number,
  revertInput: Function,
  rowData: string[][],
  rowHeader: string[],
  value: number,
};

const hashId = new HashId();

// eslint-disable-next-line react/prefer-stateless-function
export class TableSelectionGroup extends React.Component<PropsType, *> {
  static defaultProps = {
    rowHeader: [],
    rowData: [],
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const tHeader = this.props.rowHeader.map(s => <th key={s}>{s}</th>);
    const tRows = this.props.rowData.map((r: string[], k: number) => {
      const id = r[0];
      const onChange = () => this.props.changeInput({ target: { value: id } });
      const isSelected = k === this.props.inducerPos;
      const isDirty = id === this.props.dirtyVal;
      return (
        <tr
          key={id}
          className={cx(
            classes.partRow,
            {
              [classes.success]: isSelected,
              [classes.selected]: isDirty,
            },
          )}
          onClick={onChange}
        >
          <td>
            <input type="radio" checked={isSelected || isDirty} onChange={onChange} />
          </td>
          {r.map((d, l) => <td key={hashId.encode(`${k}${l}`)}>{d}</td>)}
        </tr>
      );
    });

    return (
      <Col>
        <Table responsive size="sm" hover striped className={cx(classes.table)}>
          <thead className={cx('thead-inverse')}>
            <tr>
              <th />
              {tHeader}
            </tr>
          </thead>
          <tbody>{tRows}</tbody>
        </Table>
      </Col>
    );
  }
}

function mapStateToProps(state: any, ownProps: PropsType) {
  const values = getFieldValues(state);
  const dirtyValues = getDirtyFields(state);

  const data = values[ownProps.dataTarget];
  const dirty = dirtyValues[ownProps.id];

  const inducerPos = _.get(values, ['Ind_Sel', 'currentValue'], 0) - 1;
  const tableData = _.get(data, ['currentValue'], []);
  return {
    rowData: _.tail(tableData),
    rowHeader: _.head(tableData),
    dirtyVal: dirty,
    inducerPos,
  };
}

const enhancer = compose(
  connect(mapStateToProps),
);

export default enhancer(TableSelectionGroup);



// WEBPACK FOOTER //
// ./src/components/TableSelectionGroup/TableSelectionGroup.js